export default __webpack_public_path__ + "static/media/layers.108f097e.svg";